import fetch from "auth/FetchInterceptor";

const DashboardService = {};

DashboardService.GetHRDashboard = async function () {
  return fetch({
    url: "/Dashboard/HRDashboard",
    method: "get",
  });
};
DashboardService.GetAgencyDashboard = async function (params) {
  return fetch({
    url: "/Dashboard/AgencyDashboard",
    method: "get",
    params,
  });
};
DashboardService.GetCandidateDashboard = async function (params) {
  return fetch({
    url: "/Dashboard/CandidateDashboard",
    method: "get",
    params,
  });
};
DashboardService.GetRecruiterDashboard = async function (params) {
  return fetch({
    url: "/Dashboard/RecruiterDashboard",
    method: "get",
    params,
  });
};
DashboardService.GetAssessmentDashboard = async function (params) {
  return fetch({
    url: "/Dashboard/AssessmentDashboard",
    method: "get",
    params,
  });
};
DashboardService.GetHRAssessment = async function (params) {
  return fetch({
    url: "/Dashboard/HRAssessment",
    method: "get",
    params,
  });
};

export default DashboardService;
